import "./PublicationPage.scss";
import { ContentAreaType } from "/Models/Generated/ContentAreaType";
import {
  ContentArea,
  GridRow,
  GridPresetSidebar,
  GridPresetMainContent,
  Picture,
  PublicationInfoTable,
  HeroBasic,
  HideFor,
  OptimizelyEditProperty,
} from "/App.Components";
import { PublicationPageProps } from "/Models/Generated/PublicationPageProps";
import { HasContent } from "../../Shared/ContentArea/ContentArea";
import { ContentAreaItemMargin } from "../../Shared/ContentAreaItem/ContentAreaItem";
import classNames from "classnames";
import { GridPresetSidebarMargins } from "../../Layout/GridPresetSidebar/GridPresetSidebar";

const PublicationPage = ({
  pageHeader,
  downloads,
  downloadsHeading,
  downloadsHeadingPropertyName,
  publicationInfo,
  sidebarPublicationImage,
  sidebarPublicationImagePropertyName,
  sidebarPublicationImageBorder,
  mainBody,
  sideBar,
}: PublicationPageProps) => {
  const SidebarPublicationImage = () => (
    <OptimizelyEditProperty propertyName={sidebarPublicationImagePropertyName}>
      {sidebarPublicationImage && (
        <div
          className={classNames("publication-page-norad__image", {
            "publication-page-norad__image--border":
              sidebarPublicationImageBorder,
          })}
        >
          <Picture pictureBehaviour="Cover" {...sidebarPublicationImage} />
        </div>
      )}
    </OptimizelyEditProperty>
  );
  return (
    <div className="publication-page-norad">
      {pageHeader && <HeroBasic {...pageHeader} />}
      {(mainBody || sideBar) && (
        <div className="publication-page-norad__main-body">
          <GridRow>
            <GridPresetMainContent>
              {!!downloads && HasContent(downloads) && (
                <div className="publication-page-norad__downloads">
                  <OptimizelyEditProperty
                    propertyName={downloadsHeadingPropertyName}
                  >
                    {downloadsHeading && (
                      <h2 className="publication-page-norad__heading">
                        {downloadsHeading}
                      </h2>
                    )}
                  </OptimizelyEditProperty>
                  <ContentArea
                    margin={ContentAreaItemMargin.SmallOnDesktop}
                    {...downloads}
                  />
                </div>
              )}
              {publicationInfo && <PublicationInfoTable {...publicationInfo} />}
              <HideFor desktop desktopMedium desktopLargeUp>
                <SidebarPublicationImage />
              </HideFor>
              {mainBody && (
                <ContentArea
                  {...mainBody}
                  contentAreaType={ContentAreaType.HalfWidth}
                />
              )}
            </GridPresetMainContent>
            <GridPresetSidebar
              margins={GridPresetSidebarMargins.PublicationPage}
            >
              <aside>
                <HideFor mobile tablet>
                  <SidebarPublicationImage />
                </HideFor>
                <ContentArea
                  {...sideBar}
                  contentAreaType={ContentAreaType.OneThird}
                  margin={ContentAreaItemMargin.Sidebar}
                />
              </aside>
            </GridPresetSidebar>
          </GridRow>
        </div>
      )}
    </div>
  );
};

export default PublicationPage;
